const INDEXING_DELAY_MS = 5000;

/**
 * Waits for OpenSearch and Weaviate to index updates.
 * Use after mutations that affect searchable data.
 */
export const waitForOpenSearchAndWeaviate = () =>
  new Promise((resolve) => setTimeout(resolve, INDEXING_DELAY_MS));
